import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { HEADER_MENU } from '@data/menu.data';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

const TITLE_BRAND = 'Kazunion Dashboard';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  readonly #router = inject(Router);
  readonly #title = inject(Title);
  readonly #translateService = inject(TranslateService);

  readonly #menuData = HEADER_MENU;

  /** Subscribes to router navigation and keeps the document title in sync with the active page. */
  public init(): void {
    this.#router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.#title.setTitle(this.#resolveTitle(event.url)));
  }

  #resolveTitle(routeUrl: string): string {
    if (!routeUrl) return TITLE_BRAND;

    const activatedPage = this.#menuData.find((entry) => routeUrl.includes(entry.path.substring(1)));
    if (!activatedPage?.label) return TITLE_BRAND;
    return `${TITLE_BRAND} | ${this.#translateService.instant(activatedPage.label)}`;
  }
}
